import { useCallback, useState } from 'react'

function useGuaranteeCalculationModal() {
  const [transitOperationId, setTransitOperationId] = useState<number | null>(null)

  const open = useCallback((id: number | null) => {
    if (!id) return

    setTransitOperationId(id)
  }, [])

  const close = useCallback(() => {
    setTransitOperationId(null)
  }, [])

  return {
    isOpen: transitOperationId != null,
    open,
    close,
  }
}

export default useGuaranteeCalculationModal
